import { render, staticRenderFns } from "./database-artifacts.vue?vue&type=template&id=c67a453e&scoped=true&"
import script from "./js/database-artifacts.js?vue&type=script&lang=js&"
export * from "./js/database-artifacts.js?vue&type=script&lang=js&"
import style0 from "./database-artifacts.vue?vue&type=style&index=0&id=c67a453e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67a453e",
  null
  
)

export default component.exports